import { render, staticRenderFns } from "./ForumsSection.vue?vue&type=template&id=7241f1ec"
import script from "./ForumsSection.vue?vue&type=script&lang=js"
export * from "./ForumsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports